import { Grid, Box } from '@material-ui/core';
import { PreviewSaleTransactionDataFragment } from '../../../api';
import SaleTransactionsItem from './SaleTransactionsItem';

export type SaleTransactionsBodyProps = {
    saleTransactions: PreviewSaleTransactionDataFragment[];
    hideAwardedDealer?: boolean;
    hideAwardedBitAmount?: boolean;
    hideOpenCloseBidDate?: boolean;
};

const SaleTransactionsBody = ({
    saleTransactions,
    hideAwardedDealer,
    hideAwardedBitAmount,
    hideOpenCloseBidDate,
}: SaleTransactionsBodyProps) => (
    <Box mb={3} mt={3}>
        <Grid spacing={4} container>
            {saleTransactions.map(saleTransaction => (
                <SaleTransactionsItem
                    key={saleTransaction.id}
                    hideAwardedBitAmount={hideAwardedBitAmount}
                    hideAwardedDealer={hideAwardedDealer}
                    hideOpenCloseBidDate={hideOpenCloseBidDate}
                    saleTransaction={saleTransaction}
                />
            ))}
        </Grid>
    </Box>
);

export default SaleTransactionsBody;
